<div class="diagram"  [ngClass]="{'compare':showComparison$(),'wasChange':wasChange,'inFilter':inFilter}"
    [style.background]="'linear-gradient(to top, #DBF5DE ' + percentage + '%, transparent ' + percentage + '%)'">
    <p class="prec" *ngIf="!inFilter">{{percentage}}%</p>
</div>
<p class="value" *ngIf="!showComparison$() || !isCurrent ">{{value}}</p>
